// Separated from render passes to avoid cyclic dependencies
export const rowGroupClassName = 'wp-table--group-header';
export const collapsedRowClass = '-collapsed';
